import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Tooltip } from "bootstrap"; // ? Import Bootstrap Tooltip explicitly

function Navbar({ user, setUser }) {
  const navigate = useNavigate();

  const company = JSON.parse(localStorage.getItem("selectedCompany"));
  const branch = JSON.parse(localStorage.getItem("selectedBranch"));

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("user"));
    if (userData) {
      setUser(userData);
    }

    // ? Initialize Bootstrap tooltips
    const tooltipTriggerList = [].slice.call(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    tooltipTriggerList.map((tooltipTriggerEl) => new Tooltip(tooltipTriggerEl));
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    setUser(null);
    navigate("/");
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light shadow-sm">
      {user ? (
        <div className="container-fluid">
          <Link className="navbar-brand" to="/">
            <img src="/logo.png" alt="Logo" className="brand-logo" />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#mainNavbar"
            aria-controls="mainNavbar"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div
            className="collapse navbar-collapse justify-content-end"
            id="mainNavbar"
          >
            <ul className="navbar-nav">
              <>
              <li className="nav-item">
                 <span className="nav-link">
                    {company ? (
                      <>
                        <i className="bi bi-building me-1"></i> {company.name}
                        {branch && (
                          <>
                            {" "}
                            • <i className="bi bi-geo-alt"></i> {branch.name}
                          </>
                        )}
                      </>
                    ) : null}
                  </span>
              </li>
                <li className="nav-item">
                  <span className="nav-link">Hi, {user.name}</span>
                </li>
                <li className="nav-item">
                  <button
                    className="btn btn-link nav-link"
                    onClick={handleLogout}
                    data-bs-toggle="tooltip"
                    data-bs-placement="bottom"
                    title="Logout"
                  >
                    <i
                      className="bi bi-box-arrow-right"
                      style={{ fontSize: 20, lineHeight: 0 }}
                    ></i>
                  </button>
                </li>
              </>
            </ul>
          </div>
        </div>
      ) : (
        <></>
      )}
    </nav>
  );
}

export default Navbar;
